window.cpap.onDocumentReady(() => {
  // 🚨 This is only for background logic. Nothing that is user-blocking, user-visible, or that updates the DOM on page load should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  // 🔔 Note that this background post task is intentionally delayed by 1 second. New background logic in this file should go into a new non-delayed `postTask()`.
  window.scheduler.postTask(
    () => {
      if (document.location.href.includes('page=')) {
        window.scrollTo({
          top: window.cpap.getScrollToLocation('.cpap__blogs-list'),
          behavior: 'smooth',
        });
      }
    },
    { priority: 'background', delay: 1000 }
  );
});
